import React from 'react';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import { useParkingLot } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import Table from '../../Table.js';
const WorkDescriptionCmp = (props) => {
    const { parkingLotCode } = props;
    const parkingLotLoadable = useParkingLot(parkingLotCode);
    const parkingLot = h.isLoaded(parkingLotLoadable)
        ? parkingLotLoadable.data
        : null;
    const workDescriptionSections = parkingLot?.workDescription
        .sort((a, b) => a.Line_No - b.Line_No)
        .reduce((acc, workDescription) => {
        if (acc.length === 0 || !workDescription.Comment) {
            acc = acc.concat({
                workDescriptions: [],
                header: '',
            });
        }
        if (!workDescription.Comment) {
            return acc;
        }
        const currentSection = acc[acc.length - 1];
        // Add header
        if (!currentSection.header) {
            acc[acc.length - 1].header = workDescription.Comment || '-';
            return acc;
        }
        // Add work description
        acc[acc.length - 1].workDescriptions =
            acc[acc.length - 1].workDescriptions.concat(workDescription);
        return acc;
    }, []);
    console.log({ workDescriptionSections }, parkingLot?.workDescription);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginRight: '-10px' } },
            h.isError(parkingLotLoadable) && (React.createElement(Alert, { message: 'Dataen kunne ikke hentes fra Navision.', style: {
                    backgroundColor: THEME.DANGEROUS,
                }, size: "small" })),
            parkingLot
                ? workDescriptionSections?.map(({ workDescriptions, header }) => (React.createElement(React.Fragment, null,
                    React.createElement("h4", null, header),
                    React.createElement(Table, { zebra: true }, workDescriptions.map((workDescription) => (React.createElement("tr", null,
                        React.createElement("td", null, workDescription.Comment))))),
                    React.createElement("br", null))))
                : !(h.isError(parkingLotLoadable) || h.isError(parkingLotLoadable)) && (React.createElement(React.Fragment, null,
                    React.createElement(PlaceholderLoader, { width: "200px" }),
                    React.createElement("br", null),
                    React.createElement(PlaceholderLoader, { width: "120px" }),
                    React.createElement("br", null),
                    React.createElement(PlaceholderLoader, { width: "140px" }))))));
};
export default WorkDescriptionCmp;
//# sourceMappingURL=WorkDescriptions.js.map